export function filterBy<T>(items: T[], filters: Partial<Record<keyof T, T[keyof T]>>) {
  const matchers = Object.entries(filters);

  return items.filter((item) =>
    matchers.every(([property, matcher]) => {
      if (!matcher) return true;

      const value = item[property as keyof T];

      const isString = typeof value === "string";

      let str = "";

      if (isString) {
        str = value.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      }

      return isString
        ? str.toLocaleLowerCase().includes(String(matcher).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase())
        : value === matcher;
    }),
  );
}

export function extractUniqueBy<T, K>(items: T[], selector: (item: T) => K) {
  return Array.from(new Set(items.map(selector)));
}
